import * as React from 'react';
import * as style from './Header.css';
import { UIHeading2 } from '@cian/ui-kit';
import { Link } from '../Link';

export interface IHeaderProps {
  name: string;
  url: string;
  shareButton: React.ReactElement;
  favoriteButton: React.ReactElement;
}

export const Header = ({ name, url, shareButton, favoriteButton }: IHeaderProps) => {
  return (
    <div className={style['header']} data-testid="FixedHeader">
      <UIHeading2>
        Планировки в{' '}
        <Link url={url} target="_blank">
          {name}
        </Link>
      </UIHeading2>
      <div className={style['controls']}>
        {favoriteButton}
        {shareButton}
      </div>
    </div>
  );
};
